import React from 'react';
import { CustomDialogContainer } from '../../Common/dialog/CustomDialogContainer';
import { CustomDialogTitle } from '../../Common/dialog/CustomDialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Stack from '@mui/material/Stack';
import { FormProvider } from '@sdf/base';
import { useCreateBrollCaption, CreateBrollCaptionTabs } from '../../hooks';
import { Styles, mergeSx } from '@t2c/shared-fe';
import { UploadVideo } from './UploadVideo';
import { SelectVideo } from './SelectVideo';
import Box from '@mui/material/Box';
import { UploadedModal } from './UploadedModal';
import { BrollCaptionVideo } from 'apps/t2c-fe/@types';

interface Props {
  isOpen: boolean;
  onCloseDialog: () => void;
  refetchData: () => void;
}

export const CreateBrollCaptionDialog: React.FC<Props> = ({
  isOpen,
  onCloseDialog,
  refetchData,
}) => {
  const {
    handleSubmit,
    formMethods,
    currentTab,
    handleTabChange,
    handleCloseModal,
    uploadId,
    overallPercentage,
    isProcessingVideo,
    videoDataStatus,
    handleOnRetry,
    isUploadError,
    isRetryDisable,
  } = useCreateBrollCaption({
    refetchBrollAndCaptionData: refetchData,
    closeCreateBrollCaptionDialog: onCloseDialog,
    isOpen,
  });
  const { setValue } = formMethods;

  return (
    <CustomDialogContainer open={isOpen} maxWidth={isProcessingVideo ? 'md' : 'sm'}>
      {isProcessingVideo ? (
        <UploadedModal
          uploadId={uploadId}
          onCloseDialog={onCloseDialog}
          status={videoDataStatus}
          overallPercentage={overallPercentage}
          handleCloseModal={handleCloseModal}
          handleOnRetry={handleOnRetry}
          isUploadError={isUploadError}
          isRetryDisable={isRetryDisable}
        />
      ) : (
        <FormProvider methods={formMethods} onSubmit={handleSubmit}>
          <CustomDialogTitle
            title="Create Captions & Effects"
            onClose={onCloseDialog}
            sx={styles.title}
          />

          <DialogContent sx={styles.dialogContent}>
            <Box>
              <Tabs
                value={currentTab}
                onChange={(e, newValue) => {
                  handleTabChange(newValue);
                }}
                indicatorColor="secondary"
                textColor="primary"
                sx={styles.tabsContainer}
              >
                <Tab
                  label="Upload"
                  value={CreateBrollCaptionTabs.Upload}
                  sx={mergeSx(styles.tabItem, styles.tabSpacing)}
                />
                {/* <Tab
                    label="Select Video"
                    value={CreateBrollCaptionTabs.SelectVideo}
                    sx={mergeSx(styles.tabItem, styles.tabSpacing)}
                  /> */}
              </Tabs>
            </Box>

            <Stack mt={2}>
              {currentTab === CreateBrollCaptionTabs.Upload && (
                <UploadVideo setValue={setValue} handleCloseModal={handleCloseModal} />
              )}
              {currentTab === CreateBrollCaptionTabs.SelectVideo && <SelectVideo />}
            </Stack>
          </DialogContent>
        </FormProvider>
      )}
    </CustomDialogContainer>
  );
};

const styles: Styles = {
  title: {
    paddingBottom: '10px',
    paddingTop: '10px',
  },
  dialogContent: {
    pt: 0,
    pb: 2,
    rowGap: 5,
    background: (theme) => theme.palette.background.secondary,
  },
  tabsContainer: {
    margin: 0,
    width: '60%',
  },
  tabItem: {
    minWidth: 0,
    padding: '6px 12px',
    margin: 0,
    textTransform: 'none',
  },
  tabSpacing: {
    marginRight: '0px !important',
  },
};
